import { Injectable } from '@angular/core';
import { ApmBase } from '@elastic/apm-rum';
import { NavigatorService } from '../browser-object-model/navigator.service';

@Injectable({
    providedIn: 'root'
})
export class ElasticApmCustomLabelService {

    constructor(private navigatorService: NavigatorService) {
    }

    /**
     * Adds custom labels to the current Elastic APM transaction.
     *
     * This method adds user information and network connection details as labels
     * to the provided Elastic APM transaction. The user information is retrieved
     * from the `userInfoCache` object, and the network connection details are
     * retrieved using the `navigatorService`.
     *
     * @param userInfoCache - An object containing cached user information.
     * @param userInfoCache.FirstName - The first name of the user.
     * @param userInfoCache.LastName - The last name of the user.
     * @param userInfoCache.EmailAddress - The email address of the user.
     * @param userInfoCache.IsInternalUser - A boolean indicating if the user is an internal user.
     * @param apmInstance - The current Elastic APM transaction to which the labels will be added.
     */
    addCustomLabels(userInfoCache: any, apmInstance: ApmBase) {
        apmInstance?.addLabels({
            userName: userInfoCache?.FirstName + ' ' + userInfoCache?.LastName,
            userEmail: userInfoCache?.EmailAddress,
            userType: userInfoCache?.IsInternalUser ? 'Internal' : 'External',
            hasNalcoAccesUser: userInfoCache?.HasNalcoAccesUser
        });
        if (this.navigatorService.getConnection()) {
            apmInstance?.addLabels({
                internetSpeed: this.navigatorService.getConnection()?.downlink,
                internetConnectionType: this.navigatorService.getConnection()?.effectiveType,
                rtt: this.navigatorService.getConnection()?.rtt,
                saveData: this.navigatorService.getConnection()?.saveData
            });
        }
    }
    
}
